import { FoodModel } from './../object/diet-food-model';
export class ResponseCreatePersonalFood {
  constructor(
    public statusCode: number,
    public food: personalFood,
    public message_id: number,
    public success: boolean
  ) {}
}
export class ResponseGetPersonalFood {
  constructor(
    public statusCode: number,
    public deletedFoods: string[],
    public foods: personalFood[],
    public message_id: number,
    public success: boolean
  ) {}
}
export class personalFood {
  constructor(
    public _id: string,
    public name: string,
    public suitableDiseases: string[],
    public notSuitableDiseases: string[],
    public suitableSpecialTypes: string[],
    public notSuitableSpecialTypes: string[],
    public seasons: string[],
    public notSuitableTypes: string[],
    public hatedFoods: string[],
    public deleted: boolean,
    public primaryFoodUnit: string,
    public primaryFoodUnitCalorie: number,
    public foodFact: {
      calorieAmount: number;
      proteinAmount: number;
      fatAmount: number;
      carbohydrateAmount: number;
      sugarAmount: number;
      fiberAmount: number;
      sodiumAmount: number;
      potassiumAmount: number;
      calciumAmount: number;
      magnesiumAmount: number;
      ironAmount: number;
      cholesterolAmount: number;
      phosphorAmount: number;
      saturatedFatAmount: number;
      polyunsaturatedFatAmount: number;
      transFatAmount: number;
      monounsaturatedFatAmount: number;
      _id: string;
      createdAt: string;
      updatedAt: string;
    },
    public foodUnitRatioArray: foodUnitRatioArray[],
    public createdAt: string,
    public updatedAt: string,
    public notSuitableBreastfeeding: boolean,
    public notSuitablePregnancy: boolean
  ) {}
}

export class ResponseGetRatioArray {
  constructor(
    public name: string,
    public deleted: boolean,
    public _id: string,
    public updatedAt: string,
    public createdAt: string,
    public id: string
  ) {}
}
export class FoodFactCreate {
  constructor(
    public calorieAmount: number,
    public proteinAmount: number,
    public carbohydrateAmount: number,
    public fatAmount: number,
    public sugarAmount: number,
    public fiberAmount: number,
    public sodiumAmount: number,
    public potassiumAmount: number,
    public calciumAmount: number,
    public magnesiumAmount: number,
    public phosphorAmount: number,
    public ironAmount: number,
    public saturatedFatAmount: number,
    public polyunsaturatedFatAmount: number,
    public monounsaturatedFatAmount: number,
    public transFatAmount: number,
    public cholesterolAmount: number
  ) {}
}

export class CreatePersonalFoodParams {
  constructor(
    public foodFact: FoodFactCreate,
    public name: String,
    public primaryFoodUnit: String,
    public foodUnitRatioArray?: RatioArray[]
  ) {}
}
export class RatioArray {
  constructor(public ratio: number, public unitId: string) {}
}
export class deleteResponce {
  constructor(
    public statusCode: number,
    public message_id: number,
    public success: boolean
  ) {}
}

// personal package

export class ResponsePersonalPackages {
  constructor(
    public statusCode: number,
    public deletedPackages: string[],
    public packages: Perosnlapackages[],
    public message_id: number,
    public success: boolean
  ) {}
}

export class Perosnlapackages {
  constructor(
    public deleted: boolean,
    public _id: string,
    public title: string,
    public foods: PeroanlPackagefood[],
    public user: string,
    public createdAt?: string,
    public updatedAt?: string,
    public __v?: number
  ) {}
}
export class PeroanlPackagefood {
  constructor(
    public _id: string,
    public food: string | FoodModel,
    public amount: number,
    public unit: string
  ) {}
}

export class CreatePersonalPackageParams {
  constructor(public title: string, public foods: PersonalPackageFood[]) {}
}
export class PersonalPackageFood {
  constructor(
    public food: string,
    public amount: number,
    public unit: string,
    public packageId?: string
  ) {}
}

export class foodUnitRatioArray {
  constructor(
    public ratio: number,
    public _id: string,
    public unitId: {
      _id: string;
      name: string;
      deleted: boolean;
      createdAt: string;
      updatedAt: string;
      __v: number;
    },
    public createdAt: string,
    public updatedAt: string
  ) {}
}
export class foodUnitRatioArraySample {
  constructor(
    public ratio: number,
    public _id: string,
    public unitId: string,
    public createdAt: string,
    public updatedAt: string
  ) {}
}
